// @flow

import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import Modal from "react-responsive-modal";
import { get } from "lodash";
import { Form, reduxForm } from "redux-form";
import { getClassName } from "ui-kit/utils/component";
import { Button } from "ui-kit/components";

import { Page } from "components";
import { sumbitSendInvest, deleteInvest, clearErrorMessageFromUser, goToDashboardPage } from "ducks/user/actions";
import CurrencySelector from "../../components/currencySelector";
import { getCountDecimals, getCurrencySymbol } from "../../utils/currencyHelper";
import CurrencyForm from "./form";

import "./Invest.scss";

export const ccn = getClassName("Invest");

type StateProps = {
  authorized: boolean
};

class Invest extends Component {
  state = {
    edit:             false,
    modal:            false,
    value:            0,
    invalid:          false,
    currency:         "USD",
    errorMessage:     "",
    changeAmount:     false
  };

  editStart = () => {
    const { user } = this.props;
    const { edit } = this.state;
    this.onCurrencyChange(user.invest.currency)
    this.setState({
      value:        user.invest.amount,
      edit:         !edit,
      errorMessage: ""
    });
  };

  componentWillReceiveProps(next) {
    const { user } = this.props;
    const propsBalance = user && user.invest ? user.invest : null;
    if (next.user && next.user.invest) {
      const nextBalance = next.user.invest;

      if (nextBalance) {
        if (!propsBalance || !(parseFloat(nextBalance.amount) >= 0.00) || (nextBalance.amount !== propsBalance.amount && parseFloat(nextBalance.amount) > 0.00) || nextBalance.currency !== propsBalance.currency) {
          this.setState({
            edit:         false,
            modal:        false,
            value:        nextBalance.amount,
            currency:     nextBalance.currency,
            changeAmount: false
          });
        } else if (propsBalance && nextBalance.amount === propsBalance.amount && nextBalance.currency === propsBalance.currency) { // it's need to add some condition here, since noticed bad behavior
          this.setState({ modal: false });
        }
        if (parseFloat(nextBalance.amount) === 0.00) {
          this.setState({ edit: true });
        }
      }
      if (next.errorObj) {
        this.setState({
          errorMessage: next.errorObj.data ? next.errorObj.data.message : next.errorObj,
          edit:         false,
          modal:        false
        });
        this.props.clearErrorMessageFromUser();
      }
    } else {
      this.setState({ edit: true });
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.user
      && prevProps.user.invest
      && this.props.user
      && this.props.user.invest
      && prevProps.user.invest.amount !== this.props.user.invest.amount
    ) {
      this.props.goToDashboardPage();
    }
  }

  componentDidMount() {
    // eslint-disable-next-line
    window.screen.width < 768 ? window.scrollTo({ top: 0, behavior: "smooth" }) : null;
  }

  closeModal = () => {
    this.setState({ modal: false });
  };

  cancelModal = () => {
    // eslint-disable-next-line
    window.screen.width < 768 ? window.scrollTo({ top: 0, behavior: "smooth" }) : null;
    setTimeout(() => this.setState(prev => ({ modal: true })), 290);
  };

  handleRemoveInvest = () => {
    this.setState(prev => ({
      modal: !prev.modal,
      edit:  !prev.edit,
    }));
    this.props.deleteInvest();
  };

  handleInputChange = (e) => {
    this.validateCurrency(e.target.value);
  };

  validateCurrency = (str) => {
    const { currency } = this.state;
    let value = str.replace(/[^0-9.]/g, "");

    const dotsLen = getCountDecimals(value, 2);

    // clear value if NaN detected (means restricted symbols were used)
    if (value !== '.' && isNaN(value) && value.length < 2) {
      value = "";
    } else if (isNaN(value) && !value.includes(".") && value.length > 1) {
      value = "";
    }
    // for limitating int part to 7 digits
    if (parseInt(value, 10).toString().length > 7) {
      value = value.toString().split(".")[0].slice(0, -1) + (
          (value.match(/\./g) || []).length > 0 ? "." + value.toString().split(".")[1] : ""
      );
    }
    // only one dot per investment amount is allowed or float investment amount part longer, than allowed
    // eslint-disable-next-line
    if ((value.match(/\./g) || []).length > 1 || currency === "BTC" && dotsLen > 5 || currency !== "BTC" && dotsLen > 2 && dotsLen < 4) {
      value = value.slice(0, -1);
    }
    if (currency !== "BTC" && dotsLen > 3) {
      value = value.slice(0, (value.length - dotsLen) + 2);
    }
    this.setState({
      invalid: value <= 0 || value === "" || (value !== "." && isNaN(value)),
      value
    });
  }

  onCurrencyChange = (currency) => {
    const { value } = this.state;

    this.props.change("currency", currency);
    this.setState({ currency }, () => this.validateCurrency(value.toString()));
  };

  handleSubmit = (data, dispatch) => {
    this.setState({ modal: false });
    return sumbitSendInvest(data, dispatch);
  };

  render() {
    const { edit, modal, invalid, value, currency, errorMessage, changeAmount } = this.state;
    const { handleSubmit, user, loader, intl } = this.props;
    const invest = user ? user.invest : null;
    const dotsLen = getCountDecimals(get(user, "invest.amount"), 2);

    return (
      <Page loader={loader}>
        <Form name="invest-form" onSubmit={handleSubmit(sumbitSendInvest)} className={ccn("container")}>
          {edit ? (
            <React.Fragment>
              <h1 className={ccn("title")}>
                <FormattedMessage id="hbc.header.menu1" defaultMessage="Invest"/>
              </h1>
              <p>
                <FormattedMessage id="hbc.invest.select" defaultMessage="Select asset to deposit:"/>
              </p>
              <div className={ccn("row")}>
                <CurrencySelector
                  onChange={this.onCurrencyChange}
                  currency={currency}
                  dataForFormattedMessage={{ id: "hbc.invest.title", default: "Fiat" }}
                />
              </div>
              <CurrencyForm
                invalid={invalid}
                invest={this.cancelModal}
                onInputChange={this.handleInputChange}
                currency={currency}
                setValue={value}
              />
              <p className={ccn("description")}>
                <FormattedMessage
                  id="hbc.invest.added.to.waitlist"
                  defaultMessage="Your deposit will be added to the waitlist."
                />
              </p>
              <p className={ccn("description-two")}>
                <FormattedMessage
                  id="hbc.invest.added.to.waitlist.two"
                  defaultMessage="Deposits and withdrawals are subject to asset conversion costs. Please see "
                />
                <a
                  href="https://support.hedgedbitcoin.com/hc/en-us/articles/360018818751"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage id="hbc.invest.added.to.waitlist.two.tos" defaultMessage="Terms of Service" />
                </a>
                <FormattedMessage id="hbc.invest.added.to.waitlist.two.and" defaultMessage=" and " />
                <a
                  href="https://support.hedgedbitcoin.com/hc/en-us/sections/360002645552-Deposits-and-Withdrawals"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage id="hbc.invest.added.to.waitlist.two.faq" defaultMessage="FAQ" />
                </a>.
              </p>
            </React.Fragment>
          ) : (
            <div className={ccn("container")}>
              <h1 className={ccn("title")}>
                <FormattedMessage id="hbc.header.menu1" defaultMessage="Invest"/>
              </h1>
              <h2>
                <FormattedMessage id="hbc.invest.added" defaultMessage="Added to waitlist"/>
              </h2>
              {
                <section className={ccn("deposit")}>
                  <h3 className={invest && invest.currency === "BTC" ? "btc" : null}>
                    <i>{getCurrencySymbol(get(invest, "currency"))}</i>
                    <span>
                      {invest && invest.amount ? parseFloat(invest.amount).toLocaleString("en-US", {
                        minimumFractionDigits: invest && invest.currency === "BTC" ? dotsLen : 2,
                        maximumFractionDigits: invest && invest.currency === "BTC" ? dotsLen : 2
                      }) : "0"}
                    </span>
                    <span>{` ${get(invest, "currency")}`}</span>
                  </h3>
                  {errorMessage && (
                    <div style={{ marginTop: "20px", color: "red", fontSize: "1.5em" }}>{errorMessage}</div>
                  )}
                  {invest && invest.amount > 0 && (
                    <h4 className={ccn("status")}>
                      <FormattedMessage id="hbc.dashboard.status.waitlist" defaultMessage="Status: Waitlist" />
                    </h4>
                  )}
                  <div className={ccn("btn-row")}>
                    <Button onClick={this.editStart} className="Button--modify">
                      <FormattedMessage id="hbc.invest.modify" defaultMessage="modify" />
                    </Button>
                    <Button onClick={this.cancelModal} className="Button--cancel">
                      <FormattedMessage id="hbc.invest.cancel" defaultMessage="cancel" />
                    </Button>
                  </div>
                </section>
              }
            </div>
          )}

          <Modal
            classNames={{ overlay: ccn("modal"), modal: ccn("modal-body") }}
            open={modal}
            onClose={this.closeModal}
          >
            {edit ? (
              <React.Fragment>
                <React.Fragment>
                  <h1>
                    <FormattedMessage id="hbc.invest.confirm" defaultMessage="Confirm Deposit" />
                  </h1>
                  <h2>
                    {intl.formatMessage({
                      id: "hbc.invest.confirm.message",
                      defaultMessage: "Add {AmountAndCurrency} to waitlist?"
                    }, { AmountAndCurrency: `${value} ${currency}` })}
                  </h2>
                  {changeAmount ? <h3>the amount is the same, please change the amount to another one</h3> : null}
                  <div className={ccn("btn-row")}>
                    <Button className="Button--ok-no" onClick={handleSubmit(this.handleSubmit)}>
                      <FormattedMessage id="hbc.invest.confirm.ok" defaultMessage="ok" />
                    </Button>
                    <Button className="Button--ok-no" onClick={this.closeModal}>
                      <FormattedMessage id="hbc.invest.confirm.no" defaultMessage="no" />
                    </Button>
                  </div>
                </React.Fragment>
              </React.Fragment>
            ) : (
              <React.Fragment>
                {modal &&
                (<React.Fragment>
                  <h1>
                    <FormattedMessage id="hbc.invest.cancel.deposit" defaultMessage="Cancel Deposit" />
                  </h1>
                  <h2>
                    <FormattedMessage
                      id="hbc.invest.cancel.deposit.message"
                      defaultMessage="Do you really want to cancel deposit and forfeit your spot on the waitlist?"
                    />
                  </h2>
                  <div className={ccn("btn-row")}>
                    <Button className="Button--red Button--ok-no" onClick={this.handleRemoveInvest}>
                      <FormattedMessage id="hbc.invest.cancel.deposit.ok" defaultMessage="ok" />
                    </Button>
                    <Button className="Button--ok-no" onClick={this.closeModal}>
                      <FormattedMessage id="hbc.invest.cancel.deposit.no" defaultMessage="no" />
                    </Button>
                  </div>
                </React.Fragment>)
                }

              </React.Fragment>
            )
            }
          </Modal>
        </Form>
      </Page>
    );
  }
}

const mapStateToProps = ({ user }): StateProps => ({
  user:          user.info,
  loader:        user.loader,
  errorObj:      user.error,
  initialValues: user.info ? {
    amount: get(user, "info.invest.amount", 0),
    currency: get(user, "info.invest.currency", "USD"),
    invest_type: get(user, "info.invest.currency") === "BTC" ? "bitcoin" : "money"
  } : {}
});

const InvestForm = reduxForm({
  form: "invest-form",
  enableReinitialize: true
})(Invest);

export default withRouter(connect(mapStateToProps, {
  sumbitSendInvest,
  deleteInvest,
  clearErrorMessageFromUser,
  goToDashboardPage
})(injectIntl(InvestForm)));



// WEBPACK FOOTER //
// ./src/containers/invest/Invest.js